module.exports = __webpack_public_path__ + "static/demo-screen-1-82bcf3c843c811de878424e8d8307250.jpg";